// A reusable input field for text forms
import React from "react";

interface FormInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  required?: boolean;
}

const FormInput: React.FC<FormInputProps> = ({ label, required = false, ...props }) => (
  <div className="flex flex-col gap-2 w-full">
    <label className="font-semibold text-[#1C1C1C] text-base">
      {label}{required && <span className="text-red-500 ml-1">*</span>}
    </label>
    <input
      className="rounded-md border border-[#DCE1E8] py-3 px-4 w-full placeholder-[#818BA0] focus:border-[#01545D] text-base"
      required={required}
      {...props}
    />
  </div>
);

export default FormInput;
